import { axios } from '@/services/axios';

const getTemplates = async () => {
    const res = await axios.get('/AATemplates');
    return res.data;
};

export default getTemplates;
